import type { DragonTile, InnerTile } from "@/types/dragon-tiles";

export type AudienceInnerTile = InnerTile & { audience_id: string };

/**
 * Resolve the audience id for an inner tile.
 *
 * Backend is migrating from `config.audience_id` to a top-level `audience_id`
 * (rejoiner2#645). During the rollout, we read either source — top-level wins.
 * Returns "" for the default/global inner tile.
 */
export function getAudienceId(it: InnerTile): string {
  return it.audience_id ?? it.config.audience_id ?? "";
}

export function hasAudienceId(it: InnerTile): it is AudienceInnerTile {
  return getAudienceId(it) !== "";
}

export const GLOBAL_INNER_TILE_LABEL = "Global";

export function displayInnerTileName(it: InnerTile): string {
  return hasAudienceId(it) ? it.name : GLOBAL_INNER_TILE_LABEL;
}

/** Inner tiles that have an audience_id set (i.e. not the global bucket). */
export function getAudienceInnerTiles(
  dragonTile: DragonTile,
): AudienceInnerTile[] {
  return dragonTile.inner_tiles
    .filter(hasAudienceId)
    .map((it) => ({ ...it, audience_id: getAudienceId(it) }));
}
